import { state } from '@/store/index'
import Vue from 'vue'
import { getQueryString } from './index'
const infoId = getQueryString('infoId')
function setAttributes(element, attrs) {
  Object.keys(attrs).forEach((key) => {
    if (attrs[key] || attrs[key] == 0) {
      element.setAttribute(key, attrs[key])
    }
  })
}

function updateZpm(el, binding) {
  const {
    infoid = '',
    sectionid = '',
    sortname = '',
    sortid = '',
    url = '',
    other = '',
    areaexposure = '',
    isdot = '',
    metric = '',
    info = '',
    backup = '',
    goodsexposure = '',
    legoareabackup = ''
  } = binding.value
  const zpm_attrs = {
    'zz-infoid': infoid || infoId || state.infoId,
    'zz-sectionid': sectionid,
    'zz-sortid': sortid,
    'zz-sortname': sortname,
    'zz-url': url,
    'zz-other': other,
    'data-areaexposure': areaexposure,
    'lego-goods-exposure': goodsexposure,
    'data-isdot': isdot,
    'data-metric': metric,
    'data-info': info,
    'zz-backup': JSON.stringify(backup),
    'lego-area-backup': JSON.stringify(legoareabackup)
  }
  setAttributes(el, zpm_attrs)
}

Vue.directive('zpm', {
  bind: function (el, binding) {
    updateZpm(el, binding)
  },
  update: function (el, binding) {
    updateZpm(el, binding)
  }
})

const instertDom = (target, binding) => {
  Vue.nextTick(() => {
    const parent = target.parentNode
    parent.classList.add('gradual')
    target.classList.add('vague')
    const newElement = document.createElement('img')
    newElement.classList.add('origin')
    newElement.style.cssText = 'height: 100%; width: 100%;'
    // 要先写onload 再增加src
    newElement.onload = () => {
      target.classList.add('gradual-hide_img')
      // 删除原DOM 定时器能够多设置点
      setTimeout(() => {
        target.remove()
      }, 1500)
    }
    newElement.src = binding.value.src
    if (parent.lastChild === target) {
      parent.appendChild(newElement)
    } else {
      parent.insertBefore(newElement, target.nextSibling)
    }
  })
}

Vue.directive('gradual', {
  bind(el, binding) {
    instertDom(el, binding)
  }
})
